import { StoreContract } from "@/store/constants";
import WaitTimer from '@/store/waitTimer';

import { appData } from "@/helpers/global";
import { ContractService } from "@/services/api/contract";
import { UserContractService } from "@/services/api/user-contract";

const module = {
    namespaced: true,
    timer: {
        list: new WaitTimer(StoreContract.state.list, 24 * 60 * 60),
        listRequired: new WaitTimer(StoreContract.state.listRequired, 24 * 60 * 60),
    },
    state: () => ({
        list: [],
        listRequired: [],
    }),
    mutations: {
        setList(state, data) {
            if (state.list != data) {
                state.list = data;
            }
        },
        setListRequired(state, data) {
            if (state.listRequired != data) {
                state.listRequired = data;
            }
        },
    },
    actions: {
        setList(ctx, data) {
            ctx.commit("setList", data);
            module.timer.list.resetLastFetchTime();
        },
        setListRequired(ctx, data) {
            ctx.commit("setListRequired", data);
            module.timer.listRequired.resetLastFetchTime();
        },
        loadList({ state, dispatch }, p) {
            if (p.detect && state.list.length > 0) {
                if (module.timer.list.getLastFetchTime() < p.detect) {
                    p.reset = true;
                }
                else {
                    return;
                }
            }
            if (state.list.length == 0 || p.reset || module.timer.list.isTimeExpired(module.timer.list.timeOut)) {
                ContractService.List(function (data) {
                    dispatch("setList", data);
                    p.callback();
                }, p.wait);
            }
            else {
                p.wait();
                p.callback();
            }
        },
        loadListRequired({ state, dispatch }, p) {
            if (p.detect && state.list.length > 0) {
                if (module.timer.listRequired.getLastFetchTime() < p.detect) {
                    p.reset = true;
                }
                else {
                    return;
                }
            }
            if (state.listRequired.length == 0 || p.reset || module.timer.listRequired.isTimeExpired(module.timer.listRequired.timeOut)) {
                UserContractService.List(function (data) {
                    dispatch("setListRequired", data);
                    p.callback();
                }, p.wait);
            }
            else {
                p.wait();
                p.callback();
            }
        }
    },
    getters: {
        getList(state) {
            return state.list;
        },
        getListRequired(state) {
            return state.listRequired;
        }
    }
};
export default module;